export default "__VITE_PUBLIC_ASSET__1cc641e8__"